import { telaIdsToNumber, TelasIds } from "../../../../../common/utils/tela_ids";
import { IGetObraByIdUseCase } from "../../../presentation/useCases/read/get_obra_by_id_use_case";
import { Obra } from "../../models/obra";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetObraByIdUseCase
 */

export class GetObraByIdUseCase implements IGetObraByIdUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getObraById(
    telaId: TelasIds,
    idObra: number | undefined,
  ): Promise<Obra> {
    if (idObra === undefined) throw new Error("Falha ao recuperar id da obra!");
    const response = await this.repository.getObraById(
      telaIdsToNumber(telaId),
      idObra,
    );
    if (response === null) throw new Error('Falha ao buscar obra!');
    return response;
  }
}
